import { Locale } from '../locale/types';

export interface Amount {
  value: string;
  currency: Currency;
}

export const Currency = {
  NOK: 'NOK',
  DKK: 'DKK',
  SEK: 'SEK',
  EUR: 'EUR',
  USD: 'USD',
  GBP: 'GBP',
} as const;
export type Currency = (typeof Currency)[keyof typeof Currency];

export function currencyToDisplayString(amount: Amount, locale: Locale): string {
  const unit = currencyToUnit(amount.currency, locale);
  const amountText = getAmountText(amount.value, locale);
  const nonBreakingWhitespace = ' ';
  const unitKey = unit.ownMarket ? 'unit' : 'iso';

  return `${amountText}${nonBreakingWhitespace}${unit[unitKey]}`;
}

function getAmountText(valueInMinorUnits: string, locale: Locale): string {
  const valueInMajorUnits = parseInt(valueInMinorUnits) / 100; // e.g. 1000 -> 10.00
  const onlyMinorUnitsInAmount = valueInMajorUnits < 1.0; // e.g. 0.10
  const nonZeroDecimalDigits = valueInMajorUnits % 1 != 0; // e.g. 10.10
  const showDecimalDigits = onlyMinorUnitsInAmount || nonZeroDecimalDigits;
  const minimumFractionDigits = showDecimalDigits ? 2 : 0;

  return valueInMajorUnits.toLocaleString(locale, { minimumFractionDigits });
}

function currencyToUnit(currency: Currency, locale: Locale) {
  switch (currency) {
    case Currency.NOK:
      return {
        ownMarket: locale === Locale.NO,
        unit: 'kr',
        iso: 'NOK',
      };
    case Currency.DKK:
      return {
        ownMarket: locale === Locale.DK,
        unit: 'kr.',
        iso: 'DKK',
      };
    case Currency.EUR:
      return {
        ownMarket: locale === Locale.FI,
        unit: '€',
        iso: 'EUR',
      };
    case Currency.SEK:
      return {
        ownMarket: false,
        unit: 'kr',
        iso: 'SEK',
      };
    case Currency.USD:
      return {
        ownMarket: false,
        unit: '$',
        iso: 'USD',
      };
    case Currency.GBP:
      return {
        ownMarket: false,
        unit: '£',
        iso: 'GBP',
      };
  }
}
